import React, { memo } from 'react';

import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/PrivateApps';

import styles from './QuickAppsTutorial.module.scss';

const t = i18n(keyset);

export const QuickAppsTutorial = memo(() => {
    return (
        <div className={styles.quickAppsTutorial}>
            <h4 className={styles.quickAppsTutorial__title}>{t('how-to-install')}</h4>
            <ol className={styles.quickAppsTutorial__orderedList}>
                <li>{t('tutorial-upload-apk-file')}</li>
                <li>
                    {t('tutorial-select-device-for-install')}
                    <ul className={styles.quickAppsTutorial__unorderedList}>
                        <li>{t('tutorial-tablet-apps-info')}</li>
                        <li>{t('tutorial-tv-apps-info')}</li>
                    </ul>
                </li>
                <li>{t('tutorial-wait-for-check-complete')}</li>
                <li>{t('tutorial-open-yaos-store')}</li>
                <li>{t('tutorial-go-to-my-section')}</li>
                <li>{t('tutorial-install-app-instruction')}</li>
            </ol>
        </div>
    );
});
